import { markRaw } from 'vue'
import { createResolvedUrlAudioProvider, type OAudioProvider } from '@ai/ui-components'

export const useRecordingProviderCache = () => {
  const recordingProviders = new Map<string, { url: string; provider: OAudioProvider }>()

  const getOrCreateRecordingProvider = (callId: string, url: string) => {
    const existing = recordingProviders.get(callId)
    if (existing?.url === url) return existing.provider

    existing?.provider.dispose()
    const provider = markRaw(
      createResolvedUrlAudioProvider({
        key: `cold-monitoring:${callId}`,
        cacheKey: `cold-monitoring:${callId}`,
        resolve() {
          return Promise.resolve({ url })
        },
      }),
    )
    recordingProviders.set(callId, { url, provider })
    return provider
  }

  const disposeRecordingProviders = () => {
    recordingProviders.forEach(({ provider }) => {
      provider.dispose()
    })
    recordingProviders.clear()
  }

  return {
    getOrCreateRecordingProvider,
    disposeRecordingProviders,
  }
}
